<template>
  <el-form ref="baseForm" :rules="rules" :model="fromData">
  <search-box @subSearch="subSearch" :fromData="fromData">
    <el-form-item class="item" label="选择工厂：">
      <el-select v-model="fromData.searchCriteria.factoryId" @change="getFactory" clearable filterable placeholder="请选择">
      	<el-option
      	v-for="item in factoryList"
        :label="item.value"
      	:value="item.factoryId">
      	</el-option>
      </el-select>
    </el-form-item>

    <el-form-item class="item" label="库存地：" prop="inventoryCode">
      <el-input  v-model="fromData.searchCriteria.codeOrDesc" clearable :placeholder="$store.state.remark.inventory"></el-input>
    </el-form-item>
  </search-box>
  </el-form>
</template>
<script>
import searchBox from 'components/common/search.vue';
import {factoryApi} from 'api/base.js';
import { mapState, mapActions } from 'vuex';
export default{
  components:{
    searchBox
  },
  props:{
    fromData:Object
  },
  data(){
    return{
      rules: {
        factoryCode:[{message: "",trigger: "blur"}],
        factoryDesc:[{message: '',trigger: 'change'}]
      }
    }
  },
  created(){
    this.getFactoryList();
  },
  computed:{
    ...mapState("cache",['factoryList'])
  },
  methods:{
    ...mapActions('cache',['setFactoryList']),
    //搜索
    subSearch(){
      this.$emit('subSearch');
    },
   async getFactoryList(){
      if(!this.factoryList){
        //工厂列表
        let factoryList = await this.$post(factoryApi.list,this.$store.state.getAllPage);
        if(factoryList.status){
          let listArr = factoryList.data.list;
          listArr.map((item)=>{
            return item.value = item.factoryCode+' ' + item.factoryDesc;
          });
          this.setFactoryList(listArr);
        }else{
          this.setFactoryList(null);
        }
      }
    },
    getFactory(val){
     /* let obj = this.factoryList.find(v=>v.factoryDesc === val);
      if(obj){
        this.fromData.searchCriteria.factoryCode = obj.factoryCode;
        this.fromData.searchCriteria.factoryDesc = val;
        this.fromData.searchCriteria.factoryId = obj.factoryId;
      } */
    }
  }
}
</script>

<style>
</style>
